// extracted by mini-css-extract-plugin
export default {"fixed":"dismiss_button__fixed__U4PIg","absolute":"dismiss_button__absolute__Ut82T dismiss_button__fixed__U4PIg"};